var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F4F5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 16.667L15.333 12l-4.667-4.667",
    stroke: "#191C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiIGZpbGw9IiNGNEY1RjYiLz4KPGcgb3BhY2l0eT0iMC41Ij4KPHBhdGggZD0iTTEwLjY2NjUgMTYuNjY2NkwxNS4zMzMyIDEyTDEwLjY2NjUgNy4zMzMzMSIgc3Ryb2tlPSIjMTkxQzFFIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K";
export { SvgArrowRightLight as ReactComponent };